module.exports = __webpack_public_path__ + "img/user-guide-03-06-01.792b033f.png";